import React from 'react'
import './QuoteGen.css'
import TextTransition, { presets } from "react-text-transition";


export default function QuoAuth(props)  {
    
    return(
            <div className="quoauth">
            {props.currentQuote.length<1 ? 
                <div className="quotes-out">
                    <div id="text" className="start">This is a simple quote generator that generates quotes by famous philosophers.
                    Click on Next Quote to get your first Quote!</div>
                </div>:
                <div className="quotes-out">
                    <div className="quote-icon">"</div>
                    <div className="quotes"><TextTransition text={props.currentQuote} springConfig={ presets.molasses}/></div>
                </div>}
                <div  id="author"className="author"><TextTransition text={props.author} springConfig={ presets.slow}/></div>
            </div>
        )
    }